export const getOrganisation = (state) =>
  state.usersReducer.userOrganisation ?? null;

export const getOrganisationBrand = (state) =>
  state.usersReducer.userOrganisation?.brand ?? null;
